import { topicTags } from '@/mocks/comics';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">话题热度</h2>
            <p className="text-sm text-foreground-500">最受漫友关注的热门话题标签</p>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {topicTags.map((tag, i) => (
              <a
                key={i}
                href="#topics"
                className={`inline-flex items-center gap-2 px-4 py-3 rounded-xl border text-sm font-medium transition-all cursor-pointer ${
                  tag.hot
                    ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                    : 'bg-background-50 border-background-200 text-foreground-600 hover:border-primary-200 hover:text-primary-500'
                }`}
              >
                <i className={`${tag.icon} ${tag.hot ? 'text-primary-500' : 'text-foreground-400'}`}></i>
                <span className="whitespace-nowrap">{tag.name}</span>
                <span className={`text-xs ${tag.hot ? 'text-primary-400' : 'text-foreground-400'}`}>
                  {tag.count}
                </span>
                {tag.hot && (
                  <span className="px-1.5 py-0.5 rounded-full bg-primary-500 text-white text-[10px] font-heading leading-none">
                    HOT
                  </span>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}